import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { DonateButton } from "@/components/DonateButton";

export default function DonateCancel() {
  return (
    <div className="bg-sand grain py-20" data-testid="donate-cancel-page">
      <div className="mx-auto max-w-lg px-6">
        <Reveal>
          <div className="rounded-[2rem] border border-coal/5 bg-white p-10 text-center shadow-[0_24px_60px_-24px_rgba(26,29,36,0.35)]">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-ember-subtle text-ember">
              <XCircle size={32} />
            </span>
            <h1 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-coal" data-testid="donation-cancelled-heading">
              No payment was taken
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-coal-muted">
              You cancelled before completing the donation, so nothing was charged. The learners
              will still be here whenever you are ready.
            </p>
            <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
              <DonateButton testId="cancel-retry-donate-button">Try again</DonateButton>
              <Link to="/" data-testid="cancel-home-link" className="rounded-full border border-coal/15 px-6 py-2.5 font-heading text-sm font-bold text-coal transition-colors hover:border-teal hover:text-teal">
                Back home
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
